import { watch } from "vue";
import { isReplacedRoute } from "@/utils/phones";

export default {
  install(app, { router }) {
    window.__cs_onReplacePhones = () =>
      !isReplacedRoute(router.currentRoute.value.name);

    watch(
      () => router.currentRoute.value.name,
      (name, prev) => {
        if (isReplacedRoute(name) || isReplacedRoute(prev)) {
          window.Comagic?.reinitTrackView?.();
        }
      },
      { flush: "post" }
    );
  },
};